var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullwash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fullwash",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102.841,
    height: 52.224,
    viewBox: "0 0 102.841 52.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 102.841,
    height: 52.224,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M102.647,37.722a9.26,9.26,0,0,0-1.8-3.053L99.9,28.3a.448.448,0,0,0-.38-.378L91.21,26.738c-1.009-.44-12.3-5.342-17.967-6.5a81.58,81.58,0,0,0-13.611-.842c-6.4,0-12.1.36-14.524.918-4.74,1.1-18.077,7.651-19.239,8.224-1.45.226-19.22,3-21.055,3.513-1.916.537-3.457,4.227-3.768,5.022A2.941,2.941,0,0,0,0,39.308c.073,1.1.222,6.65.223,6.707a.45.45,0,0,0,.385.432L9.5,47.717a.526.526,0,0,0,.056,0l.229,0H9.8a.449.449,0,0,0,.448-.448V44.562a.392.392,0,0,0,.022-.136V44.36c0-.025,0-.049,0-.075a7.9,7.9,0,1,1,15.79,0c0,.025,0,.049,0,.073l0,.068a.5.5,0,0,0,.023.149v2.994a.447.447,0,0,0,.441.448l.158,0,44.987.15h.033l.117-.008a.449.449,0,0,0,.416-.448V45.023a.433.433,0,0,0,.023-.148v-.067c0-.024,0-.049,0-.074a7.894,7.894,0,1,1,15.788,0c0,.024,0,.047,0,.07l0,.071a.452.452,0,0,0,.022.147v1.506a.448.448,0,0,0,.449.449h.029l.046,0a.284.284,0,0,0,.041,0l11.356-1.793a.449.449,0,0,0,.3-.184l2.017-2.839a.483.483,0,0,0,.058-.113,8.239,8.239,0,0,0,.3-4.317M34.4,41.782c0-3.326-1.535-4.86-4.86-4.86,3.325,0,4.86-1.535,4.86-4.86,0,3.325,1.534,4.86,4.859,4.86-3.325,0-4.859,1.534-4.859,4.86M53.824,29.755l-23.671.706s7.78-5.693,15.8-8.182a34.267,34.267,0,0,1,7.868-.881Zm4.593-.136V21.391a49.438,49.438,0,0,1,9.955,1C72.855,23.624,79.019,29,79.019,29Zm26.227,6.542c0-3.325-1.535-4.86-4.86-4.86,3.325,0,4.86-1.534,4.86-4.859,0,3.325,1.535,4.859,4.86,4.859-3.325,0-4.86,1.535-4.86,4.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M18.159,37.884a7.17,7.17,0,1,0,7.17,7.169,7.177,7.177,0,0,0-7.17-7.169m0,11.939a4.77,4.77,0,1,1,4.769-4.77,4.775,4.775,0,0,1-4.769,4.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M80.307,37.884a7.17,7.17,0,1,0,7.168,7.169,7.178,7.178,0,0,0-7.168-7.169m0,11.939a4.77,4.77,0,1,1,4.768-4.77,4.775,4.775,0,0,1-4.768,4.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M92.54,24.59c0-4.894,2.259-7.153,7.153-7.153-4.894,0-7.153-2.259-7.153-7.154,0,4.9-2.259,7.154-7.153,7.154,4.894,0,7.153,2.259,7.153,7.153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M48.343,17.312c0-4.894,2.259-7.153,7.153-7.153-4.894,0-7.153-2.259-7.153-7.153,0,4.894-2.259,7.153-7.153,7.153,4.894,0,7.153,2.259,7.153,7.153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M85.623,9.719c0-3.325,1.535-4.86,4.86-4.86-3.325,0-4.86-1.534-4.86-4.859,0,3.325-1.535,4.859-4.86,4.859,3.325,0,4.86,1.535,4.86,4.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M29.674,10.23c0-3.325,1.535-4.86,4.86-4.86-3.325,0-4.86-1.534-4.86-4.86,0,3.326-1.535,4.86-4.86,4.86,3.325,0,4.86,1.535,4.86,4.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M15.9,27.273c0-4.894,2.259-7.153,7.153-7.153-4.894,0-7.153-2.259-7.153-7.154,0,4.9-2.259,7.154-7.153,7.154,4.894,0,7.153,2.259,7.153,7.153"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullwash);
export default __webpack_public_path__ + "static/media/fullwash.d78d28cef35345d3e1db3f4b2a8571e1.svg";
export { ForwardRef as ReactComponent };